<span *ngIf="inPageNav && inPageNav=='HIGH' " class="riskLable gds-status-tag red">{{inPageNav}}</span>
<span *ngIf="inPageNav && inPageNav=='MEDIUM' " class="riskLable gds-status-tag orange">{{inPageNav}}</span>
<span *ngIf="inPageNav && inPageNav=='LOW' " class="riskLable gds-status-tag green">{{inPageNav}}</span>
